module.exports = __webpack_public_path__ + "static/img/subcontract12.83d07c4b.png";